import { generateColorRamps } from './color-ramps-generator';
export var generateThemeBranding = function generateThemeBranding(primaryColour) {
  return generateColorRamps(primaryColour);
};